import React from "react";
import profilePhoto from "../../assets/images/about-me.png";
import ReadFieldNotes from "../../assets/images/read-field-notes.png";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="container">
        <div className="hero__inner">
          <div className="hero__image">
            <div className="hero__photo-wrapper">
              <div className="hero__photo-ring" aria-hidden="true"></div>
              {/* <div aria-hidden="true"></div> */}
              <img
                className="hero__photo"
                src={profilePhoto}
                alt="Ashish S — Software Engineer"
                loading="eager"
              />
            </div>
          </div>
          <div className="hero__content">
            <h1 className="hero__greeting">
              <span className="hero__name-highlight">Hi, I'm Ashish</span>
            </h1>
            <p className="hero__title">
              ENGINEERING SCALABLE SYSTEMS, AUTOMATING WHAT MATTERS
            </p>
            <div className="hero__description" style={{ fontSize: "15px" }}>
              I'm a Software Engineer specializing in software architecture,
              backend engineering, and AI workflow automation, with hands-on
              experience building serverless applications on AWS.
            </div>

            <div className="hero__description" style={{ fontSize: "15px" }}>
              Previously architected and built HustleBot, an AI-powered cold
              outreach platform that helped secure <b>$500K+ in funding</b>,
              scaled to <b>500+ active campaigns</b>, and delivered over{" "}
              <b>1M+ emails per day</b>.
            </div>

            {/* <div className="hero__description" style={{
              fontSize: "13px", 
              width: "100%",
              fontWeight: "bold",
              alignItem: "center"
              }}>
              TECHNICAL PLAN <span className="about__highlight" style={{marginLeft: "5px", marginRight: "5px", }}>⮕</span>MVP DEVELOPMENT <span className="about__highlight" style={{marginLeft: "5px", marginRight: "5px"}}>⮕</span> SCALE
            </div> */}

            <div className="hero__socials">
              <a
                href="https://linkedin.com/in/ashish-subedi-a6496a170/"
                className="hero__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              <a
                href="https://github.com/Scorpi35"
                className="hero__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                </svg>
              </a>
              {/* <a
                href="https://instagram.com"
                className="hero__social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a> */}
            </div>

            <div className="hero__actions">
              <a
                href="https://calendly.com/connect-with-ashish-subedi"
                className="btn btn--outline"
                id="hero-cta-case-studies"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book a Call
              </a>
              <a
                href="#products"
                className="btn btn--outline"
                id="hero-cta-resume"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("blogs")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <img
                  src={ReadFieldNotes}
                  alt={ReadFieldNotes}
                  style={{ height: "30px", width: "30px" }}
                />
                Read Field Notes
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
